import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { useAuth, formatApiError } from "@/contexts/AuthContext";

export default function Signup() {
  const nav = useNavigate();
  const { signup } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password.length < 8) { setErr("Password must be at least 8 characters."); return; }
    setLoading(true);
    try {
      await signup(email.trim(), password, name.trim());
      nav("/account", { replace: true });
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="signup-page" className="bg-[#050505] text-white pt-32 min-h-screen">
      <div className="px-6 md:px-12 lg:px-24 pb-24 max-w-md mx-auto">
        <p className="eyebrow mb-4">Create account</p>
        <h1 className="font-display text-4xl sm:text-5xl font-medium tracking-tight mb-2">
          Join Stageletics
        </h1>
        <p className="text-zinc-400 mb-12 text-sm">
          Save your shipping details, view order history, and reorder in one click.
        </p>

        <form onSubmit={submit} className="border border-white/10 bg-white/[0.02] p-8 space-y-6">
          <div>
            <label className="eyebrow mb-2 block">Full name</label>
            <input
              data-testid="signup-name-input"
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-white text-white px-0 py-3 focus:outline-none"
              placeholder="Pat Johnson"
            />
          </div>
          <div>
            <label className="eyebrow mb-2 block">Email</label>
            <input
              data-testid="signup-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-white text-white px-0 py-3 focus:outline-none"
              placeholder="you@church.org"
            />
          </div>
          <div>
            <label className="eyebrow mb-2 block">Password (min 8 chars)</label>
            <input
              data-testid="signup-password-input"
              type="password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-white text-white px-0 py-3 focus:outline-none"
            />
          </div>
          {err && <p data-testid="signup-error" className="text-sm text-red-400">{err}</p>}
          <button
            data-testid="signup-submit-button"
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center disabled:opacity-50"
          >
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Creating…</> : <>Create account <ArrowRight className="w-4 h-4" /></>}
          </button>
        </form>

        <p className="text-sm text-zinc-500 mt-8 text-center">
          Already have an account?{" "}
          <Link to="/login" data-testid="signup-to-login-link" className="text-white underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
